import PropTypes from 'prop-types'
import styled from 'styled-components'

import { FadeUp } from '@happymoneyinc/move'

import Container from '../Container'
import Display from '../Display'

const Intro = (props) => {
  const {
    data: {
      intro_text: text
    }
  } = props

  return (
    <Wrapper center>
      <FadeUp><StyledText size="small" element="h2">{text}</StyledText></FadeUp>
    </Wrapper>
  )
}

const Wrapper = styled(Container)`
  text-align: center;
  background-color: ${ ({ theme }) => theme.colors.chartreuse[3] };

  > div {
    padding-right: 35px;
    padding-left: 35px;
  }
`

const StyledText = styled(Display)`
  max-width: 666px;
  margin: 0;
  font-size: 26px;
  font-weight: 400;
  line-height: 150%;

  @media screen and (min-width: ${ ({ theme }) => theme.breakpoints.sm }) {
    font-size: 32px;
  }
`

Intro.propTypes = {
  data: PropTypes.objectOf(PropTypes.string).isRequired,
}

export default Intro
